import React, {useEffect, useState, FunctionComponent} from "react";
import {makeStyles, createStyles, useTheme, Theme} from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import {
    Typography,
    Button,
    TextField, Box, CardMedia, IconButton, Dialog
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import API from "../../../helpers/apiHelpers";
import {useHistory, useLocation} from "react-router-dom";
import {reasonsForVisit, reasonForVisitAtlanta} from "../../../Constants/reasonsForVisit";
import {visitOutcomes} from "../../../Constants/visitOutcomes";
import {useFormik} from "formik";
import * as yup from "yup";
import {RootState, useAppDispatch} from "../../../redux/store";
import {useSelector, useDispatch} from "react-redux";
import {
    patchAppointment,
    getAppointmentNotes,
    getPrescriptions,
    patchAppointmentNotes,
    setAppointmentNotes
} from "../../../redux/appointment/appointment.actions";
import {useSnackbar} from "notistack";
import {useLightbox} from "simple-react-lightbox";
import {api_getHandouts} from "../../../redux/appointment/appointment.api";
import Image from "material-ui-image";
import {ReactComponent as LogoSVG} from "../../../Images/logo.svg";
import {setImage, updateShowVideo} from "../../../redux/images/images.actions";
import PlayCircleOutlineIcon from "@material-ui/icons/PlayCircleOutline";
import ReactWebMediaPlayer from "react-web-media-player";
import {SRLWrapper} from "simple-react-lightbox";
import {ReactComponent as PlayCircle} from "../../../Images/PlayCircleWhite.svg";

interface Props {
    data: any,
    isFinished: boolean | null;
    isMobile: boolean;
    setIsFinished: React.Dispatch<any>;
    hasConfirmedInfo: string;
    leave: any;
    videoChatIsClosed?: null | string,
    setVideoChatIsClosed?: (string) => void,
}

const useStyle = makeStyles((theme: Theme) => createStyles({
    topSpacing: {
        paddingTop: "20px",
    },
    root: {
        display: "flex",
        width: "90%",
        marginTop: 20,
        alignSelf: "center",
    },
    details: {
        display: "flex",
        flexDirection: "column",
        marginLeft: 10,
        width: "100%"
    },
    content: {
        flex: "auto",
        width: "100%"
    },
    appointmentInfo: {
        width: "100%",
        paddingBottom: 10
    },
    btnWrapper: {
        display: "flex",
        flexDirection: "row"
    },
    submitBtn: {
        marginRight: "20px"
    },
    optionBtn: {
        minWidth: 100,
        marginRight: 10,
        marginBottom: 3,

    },
    videoCard: {
        position: "relative"
    },
    videoBtn: {
        color: "#000",
        width: "2em",
        height: "2em",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        fontSize: "2em"
    },
    videoDialog: {
        "& .MuiDialog-paper": {
            overflowY: "hidden",
        },
        "& .MuiDialog-paperFullWidth": {
            width: "unset",
        },
    },
}));

//Create the various validation schemas for each form:
//SOAP/NOTES

const NoteEdit: FunctionComponent<Props> = ({data, isFinished, setIsFinished, isMobile, hasConfirmedInfo, leave, setVideoChatIsClosed, videoChatIsClosed}: Props) => {
    const {imageUrl, videoUrl} = data.data.item;
    const [user, setUser] = useState<undefined | any>();
    const classes = useStyle();
    const history = useHistory();
    const dispatch = useAppDispatch();
    const {openLightbox} = useLightbox();
    const appointmentData = useSelector((state: RootState) => state?.appointment.appointment);
    const [result, setResult] = useState(null);
    const [existingNoteId, setExistingNoteId] = useState(null);
    const {enqueueSnackbar} = useSnackbar();
    const [isCreated, setIsCreated] = useState(false);
    const [handouts, setHandouts] = useState(null);
    const [handout, setHandout] = useState(null);
    const images = useSelector((state: RootState) => state?.images.images);
    const imageObj = useSelector((state: RootState) => state?.images.images);
    const showVideo = useSelector((state: RootState) => state?.images.showVideo);
    const isWhiteLabel = useSelector((state: RootState) => state?.branding.partnerPreferencesOn);
    const logo = useSelector((state: RootState) => state?.branding.logo);
    const [noteState, setNoteState] = useState({
        appointment: data?.hasOwnProperty("data") ? data.data.item : [],
        comments: "",
        ownerConcerns: data?.hasOwnProperty("data") ? data.data.item.description : "",
        subjective: "",
        objective: "",
        assessment: "",
        plan: data.data.item.animal.primaryVetName === "East Atlanta Animal Clinic" ? "Date of in-person wellness appointment:\n" +
            "Recommended that pet parent ask the following questions during their first in-person wellness exam:\n" +
            "1) What medical insurance is available for my pet and is it right for my pet?\n" +
            "2) How can I receive my pet's preventative medications? What happens when I need refills?" : "",
        reasonForVisit: data.data.item.animal.primaryVetName === "East Atlanta Animal Clinic" ? reasonForVisitAtlanta : [],
        otherReasonForVisit: "",
        appointmentId: data?.hasOwnProperty("data") ? data.data.item.id : 0,
        visitOutcome: result !== null ? result?.value : null,
        // contactUsInfo: ""
    });
    const lightBoxOptions = {
        settings: {
            autoplaySpeed: 0,
            downloadedFileName: "image"
        },
        thumbnails: {
            showThumbnails: false
        },
        buttons: {
            showNextButton: false,
            showPrevButton: false,
        }
    };
    // const contactUsDefault = `Our normal business hours are 9am - midnight EST. If your pet has a medical emergency after hours, and you cannot reach Hello Ralphie's support team at one of the contact methods below, please seek care immediately at the closest veterinary emergency hospital. If you have questions or concerns or need to schedule any follow-up appointments with a Hello Ralphie veterinarian please contact us. You can also schedule appointments directly via the Hello Ralphie App or on the Web.\n\n-Hello Ralphie Contact Information\n-Email: support@helloralphie.com\n-Phone: (917) 259-0518\n-Website: helloralphie.com (click the chat box in the lower right hand corner)`

    //Validation if needed:
    const otherValidation = yup.object({
        otherReasonForVisit: yup.string().required("Required field"),
    });

    useEffect(() => {
        api_getHandouts()
            .then((res) => {
                setHandouts(res);
            });
    }, []);
    //Form Hooks:

    const notesFormik = useFormik({
        initialValues: noteState,
        enableReinitialize: true,
        onSubmit: async (values, {setStatus}) => {
            //Check if there should be an other reason:
            if (existingNoteId == null) {
                if (!isCreated) {
                    setIsCreated(true);
                    await dispatch(setAppointmentNotes({
                        appointmentId: values.appointmentId,
                        ownerConcerns: values.ownerConcerns,
                        assessment: values.assessment,
                        plan: values.plan,
                        subjective: values.subjective,
                        objective: values.objective,
                        reasonForVisit: values.reasonForVisit.map(item => item.value),
                        comments: values.comments,
                        visitOutcome: result !== null ? result.value : null,
                        otherReasonForVisit: values.otherReasonForVisit,
                        handouts: handout ? [handout] : []
                    }))
                        .then((res) => {
                            setExistingNoteId(res.id);
                            enqueueSnackbar("Success!", {
                                variant: "success",
                                autoHideDuration: 4000
                            });
                        })
                        .catch(() => {
                            enqueueSnackbar("Something went wrong! Please try again.", {
                                variant: "error",
                                autoHideDuration: 4000
                            });
                        });
                }
            } else {
                await dispatch(patchAppointmentNotes(existingNoteId, {
                    ownerConcerns: values.ownerConcerns,
                    assessment: values.assessment,
                    plan: values.plan,
                    subjective: values.subjective,
                    objective: values.objective,
                    reasonForVisit: values.reasonForVisit.map(item => item.value),
                    comments: values.comments,
                    visitOutcome: result !== null ? result.value : null,
                    otherReasonForVisit: values.otherReasonForVisit,
                    handouts: handout ? [handout] : []
                })).then(() => {
                    enqueueSnackbar("Success!", {
                        variant: "success",
                        autoHideDuration: 4000
                    });
                })
                    .catch(() => {
                        enqueueSnackbar("Something went wrong! Please try again.", {
                            variant: "error",
                            autoHideDuration: 4000
                        });
                    });
            }
            dispatch(patchAppointment(data.data.item.id, {
                finished: true,
            }));
            // history.push({pathname: "/apointmentPrescriptions", state: {appointmentId: data.data.item.id}});
            // history.push({ pathname: "/apointmentRate", state: { appointmentId: data } });

        }
    });

    const getNotesValues = async () => {
        const notesData = await dispatch(getAppointmentNotes({appointmentId: data.data.item.id})).then(results => {
            return results;
        });
        if (notesData.length > 0) {
            setResult(visitOutcomes.filter(item => item?.value === notesData[0].visitOutcome)[0]);
            setExistingNoteId(notesData[0].id);
            setHandout(notesData[0]?.handouts[0]);
            notesFormik.setFieldValue("appointment", data.data.item);
            notesFormik.setFieldValue("comments", notesData[0].comments);
            notesFormik.setFieldValue("ownerConcerns", data.data.item.description);
            notesFormik.setFieldValue("subjective", notesData[0].subjective);
            notesFormik.setFieldValue("objective", notesData[0].objective);
            notesFormik.setFieldValue("assessment", notesData[0].assessment);
            notesFormik.setFieldValue("plan", (!notesData[0].plan.length && data.data.item.animal.primaryVetName === "East Atlanta Animal Clinic") ? "Date of in-person wellness appointment:\n" +
                "Recommended that pet parent ask the following questions during their first in-person wellness exam:\n" +
                "1) What medical insurance is available for my pet and is it right for my pet?\n" +
                "2) How can I receive my pet's preventative medications? What happens when I need refills?" : notesData[0].plan);
            notesFormik.setFieldValue("reasonForVisit", data.data.item.animal.primaryVetName === "East Atlanta Animal Clinic" ? reasonForVisitAtlanta : notesData[0].reasonForVisit.map(item => reasonsForVisit.filter(res => res?.value === item)[0]));
            notesFormik.setFieldValue("otherReasonForVisit", notesData[0].otherReasonForVisit);
            notesFormik.setFieldValue("appointmentId", data.data.item.id);
            notesFormik.setFieldValue("visitOutcome", result !== null ? result?.value : "");
            // notesFormik.setFieldValue("contactUsInfo", notesData[0].hasOwnProperty("contactUsInfo") ? notesData[0].contactUsInfo : contactUsDefault);
        }
    };

    //appointment status func
    const requestAppointment = async () => {
        // eslint-disable-next-line no-prototype-builtins
        appointmentData.hasOwnProperty("finished") ? setIsFinished(appointmentData.finished) : setIsFinished(false);
    };

    useEffect(() => {
        requestAppointment();
        if (data?.hasOwnProperty("data")) {
            getNotesValues();
        }
    }, []);
    const autoSaveNotes = async (values) => {
        if (existingNoteId == null) {
            if (!isCreated) {
                setIsCreated(true);
                await dispatch(setAppointmentNotes({
                    appointmentId: values.appointmentId,
                    ownerConcerns: values.ownerConcerns,
                    assessment: values.assessment,
                    plan: values.plan,
                    subjective: values.subjective,
                    objective: values.objective,
                    reasonForVisit: values.reasonForVisit.map(item => item.value),
                    comments: values.comments,
                    visitOutcome: result !== null ? result.value : null,
                    otherReasonForVisit: values.otherReasonForVisit,
                    handouts: handout ? [handout] : []
                }))
                    .then((res) => {
                        setExistingNoteId(res.id);
                    })
                    .catch(() => {
                        enqueueSnackbar("Something went wrong! Please try again.", {
                            variant: "error",
                            autoHideDuration: 4000
                        });
                    });
            }
        } else {
            await dispatch(patchAppointmentNotes(existingNoteId, {
                ownerConcerns: values.ownerConcerns,
                assessment: values.assessment,
                plan: values.plan,
                subjective: values.subjective,
                objective: values.objective,
                reasonForVisit: values.reasonForVisit.map(item => item.value),
                comments: values.comments,
                visitOutcome: result !== null ? result?.value : null,
                otherReasonForVisit: values.otherReasonForVisit,
                handouts: handout ? [handout] : []
            })).then(() => {
            })
                .catch(() => {
                    enqueueSnackbar("Something went wrong! Please try again.", {
                        variant: "error",
                        autoHideDuration: 4000
                    });
                });
        }
    }
    return (
        <Box>
            <form onSubmit={notesFormik.handleSubmit} className={classes.topSpacing} style={{paddingLeft: 25}}>
                <Grid container>
                    <Grid item xs={12}>
                        <Typography>
                            Reason for Visit
                        </Typography>
                        <Autocomplete
                            id="reasonForVisit"
                            multiple
                            limitTags={2}
                            value={notesFormik.values.reasonForVisit}
                            onChange={(event, value) => {
                                notesFormik.setFieldValue("reasonForVisit", value);
                            }}
                            onBlur={() => {autoSaveNotes(notesFormik.values);}}
                            options={data.data.item.animal.primaryVetName === "East Atlanta Animal Clinic" ? reasonForVisitAtlanta : reasonsForVisit}
                            getOptionLabel={(option) => option.type}
                            style={{width: "85%", marginBottom: 10}}
                            disabled={data.data.item.animal.primaryVetName === "East Atlanta Animal Clinic"}
                            renderInput={(params) => <TextField {...params} variant="outlined"/>}
                        />
                    </Grid>
                    {(imageUrl || videoUrl) &&
                        <Grid item xs={12}>
                            <Typography>
                                Uploaded photos & video
                            </Typography>
                            <Box display="flex" flexWrap="wrap" marginBottom="20px" marginTop="10px">
                                {
                                    imageUrl &&
                                    imageUrl.map((url, idx) =>
                                        <Box key={idx} width="27%" height="auto" marginRight="5px" marginBottom="10px">
                                            <Image
                                                src={url} errorIcon={<LogoSVG/>}
                                                imageStyle={{objectFit: "cover", width: "100%", height: "100%"}}
                                                style={{cursor: "pointer"}}
                                                onClick={() => {
                                                    dispatch(setImage(url));
                                                    setTimeout(() => {
                                                        openLightbox(0);
                                                    }, 100);
                                                }}
                                            />
                                        </Box>)
                                }
                                {
                                    videoUrl &&
                                    <Box width="27%" height="auto" marginRight="5px" marginBottom="10px" className={classes.videoCard}
                                         onClick={() => {
                                             dispatch(setImage(videoUrl));
                                             dispatch(updateShowVideo(true));
                                         }}
                                    >
                                        <CardMedia
                                            height="100%"
                                            src={isWhiteLabel ? logo : require("../../../Images/CircleLogo.png")}
                                            component="img"
                                        />
                                        <IconButton aria-label="add an alarm" className={classes.videoBtn}
                                        >
                                            {!isWhiteLabel ? <PlayCircle
                                                style={{
                                                    width: "2em",
                                                    height: "2em",
                                                }}
                                            />
                                                : <PlayCircleOutlineIcon
                                                    style={{
                                                        width: "2em",
                                                        height: "2em",
                                                    }}
                                                />}
                                        </IconButton>
                                    </Box>
                                }
                            </Box>
                        </Grid>
                    }
                    {notesFormik.values.reasonForVisit.filter(item => item.value === "OTHER").length > 0 &&
                        <Grid item xs={12}>
                            <Typography>
                                Other Reason
                            </Typography>
                            <TextField
                                id="otherReasonForVisit"
                                value={notesFormik.values.otherReasonForVisit}
                                onChange={notesFormik.handleChange}
                                onBlur={() => {autoSaveNotes(notesFormik.values);}}
                                style={{width: "85%", marginBottom: 10}}
                                variant="outlined"
                            />
                        </Grid>
                    }
                    <Grid item xs={12}>
                        <Typography>
                            Owner Concerns
                        </Typography>
                        <TextField
                            id="ownerConcerns"
                            multiline
                            value={notesFormik.values.ownerConcerns}
                            onChange={notesFormik.handleChange}
                            onBlur={() => {autoSaveNotes(notesFormik.values);}}
                            style={{width: "85%", marginBottom: 10}}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography>
                            Subjective
                        </Typography>
                        <TextField
                            id="subjective"
                            multiline
                            value={notesFormik.values.subjective}
                            onChange={notesFormik.handleChange}
                            onBlur={() => {autoSaveNotes(notesFormik.values);}}
                            style={{width: "85%", marginBottom: 10}}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography>
                            Objective
                        </Typography>
                        <TextField
                            id="objective"
                            multiline
                            value={notesFormik.values.objective}
                            onChange={notesFormik.handleChange}
                            onBlur={() => {autoSaveNotes(notesFormik.values);}}
                            style={{width: "85%", marginBottom: 10}}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography>
                            Assessment
                        </Typography>
                        <TextField
                            id="assessment"
                            multiline
                            value={notesFormik.values.assessment}
                            onChange={notesFormik.handleChange}
                            onBlur={() => {autoSaveNotes(notesFormik.values);}}
                            style={{width: "85%", marginBottom: 10}}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography>
                            Plan
                        </Typography>
                        <TextField
                            id="plan"
                            multiline
                            value={notesFormik.values.plan}
                            onChange={notesFormik.handleChange}
                            onBlur={() => {autoSaveNotes(notesFormik.values);}}
                            style={{width: "85%", marginBottom: 10}}
                            variant="outlined"
                        />
                    </Grid>
                    {/* <Grid item xs={12}>
					<Typography>
                        Contact Information
					</Typography>
					<TextField
						id="contactUsInfo"
						multiline
						value={notesFormik.values.contactUsInfo}
						onChange={notesFormik.handleChange}
						style={{ width: "85%", marginBottom: 10 }}
						variant="outlined"
					/>
				</Grid> */}
                    <Grid item xs={12}>
                        <Typography>
                            Outcome
                        </Typography>
                        <Autocomplete
                            id="visitOutcome"
                            options={visitOutcomes}
                            value={result}
                            onChange={(event, value) => {
                                setResult(value);

                            }}
                            onBlur={() => {autoSaveNotes(notesFormik.values);}}
                            getOptionLabel={(option) => option.label}
                            style={{width: "85%", marginBottom: 20}}
                            renderInput={(params) => <TextField {...params} variant="outlined"/>}
                        />
                    </Grid>
                    {handouts?.length
                        &&
                        <Grid item xs={12}>
                            <Typography>
                                Handout
                            </Typography>
                            <Autocomplete
                                id="handout"
                                options={handouts}
                                value={handout}
                                onChange={(e, value) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setHandout(value);
                                }}
                                onBlur={() => {autoSaveNotes(notesFormik.values);}}
                                getOptionLabel={(option) => option.name}
                                style={{width: "85%", marginBottom: 20}}
                                renderInput={(params) => <TextField {...params} variant="outlined"/>}
                                renderOption={(option) => {
                                    const isSelected = option?.name === handout?.name;
                                    return (
                                        <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
                                            <Box marginRight="3px">
                                                {option?.name}
                                            </Box>
                                            <Box width="100px">
                                                {option?.path
                                                    &&
                                                    <Button
                                                        variant="outlined"
                                                        color="primary"
                                                        className={classes.optionBtn}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            window.open(option.path);
                                                        }}
                                                    >
                                                        View
                                                    </Button>}
                                                <Button
                                                    variant={isSelected ? "contained" : "outlined"}
                                                    color="primary"
                                                    className={classes.optionBtn}
                                                    onClick={(e) => {
                                                        setHandout(isSelected ? null : option);
                                                    }}
                                                >
                                                    {isSelected ? "Deselect" : "Select"}
                                                </Button>
                                            </Box>
                                        </Box>
                                    );
                                }}
                            />
                        </Grid>}
                    <Grid item xs={12}>
                        <div className={classes.btnWrapper}>
                            <Button
                                style={{width: "85%", marginBottom: 20}}
                                variant="contained"
                                color="secondary"
                                onClick={() => {
                                    if (hasConfirmedInfo !== "true") {
                                        enqueueSnackbar("Please verify the Patient and Client information before submitting.", {
                                            variant: "error",
                                            autoHideDuration: 4000
                                        });
                                    } else {
                                        leave();
                                        setVideoChatIsClosed("logout");
                                    }
                                }
                                }
                            >
                                End Appointment & Save Notes
                            </Button>
                        </div>
                    </Grid>
                </Grid>
            </form>
            <SRLWrapper
                elements={imageObj}
                options={lightBoxOptions}
            />
            <Dialog
                fullWidth={true}
                className={classes.videoDialog}
                onClose={() => dispatch(updateShowVideo(false))}
                open={showVideo}
                disableEnforceFocus
            >
                <ReactWebMediaPlayer
                    style={{marginBottom: 0,}}
                    video={imageObj[0].src}
                />
            </Dialog>
        </Box>
    );
};

export default NoteEdit;
